const isBrowser = () => typeof window !== "undefined";
const hasClarity = () => isBrowser() && typeof window.clarity === "function";

export const trackClarityEvent = (name, payload = {}) => {
  if (!hasClarity()) {
    return;
  }

  try {
    window.clarity("event", name, payload);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`Failed to track Clarity event "${name}"`, error);
    }
  }
};

export const setClarityUserContext = (payload = {}) => {
  if (!hasClarity()) {
    return;
  }

  try {
    Object.entries(payload).forEach(([key, value]) => {
      window.clarity("set", key, value);
    });
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("Failed to set Clarity user context", error);
    }
  }
};
